import { render, staticRenderFns } from "./VendorDetail.vue?vue&type=template&id=3369ef43&scoped=true"
import script from "./VendorDetail.vue?vue&type=script&lang=js"
export * from "./VendorDetail.vue?vue&type=script&lang=js"
import style0 from "./VendorDetail.vue?vue&type=style&index=0&id=3369ef43&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3369ef43",
  null
  
)

export default component.exports